import TxPlanCard from "./TxPlanCard";
import { formatMoney } from "./pipelineHelpers";

// One kanban column. Sticky header with state name, count, and column
// total. Cards scroll inside the column.
export default function KanbanColumn({ state, plans, currency = "PHP", onOpen }) {
  const Icon = state.Icon;
  const total = plans.reduce((acc, p) => acc + (p.total_centavos || 0), 0);
  return (
    <div
      data-testid={`kanban-column-${state.key}`}
      className={[
        "shrink-0 w-[82vw] md:w-[280px] snap-start rounded-lg border-2 flex flex-col",
        state.column,
      ].join(" ")}
    >
      <div className="sticky top-0 z-10 px-3 py-2 border-b border-black/5 bg-inherit rounded-t-md">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 min-w-0">
            <Icon className={["w-4 h-4 shrink-0", state.accent].join(" ")} strokeWidth={2.5} />
            <span className="text-[13px] font-semibold text-slate-900">{state.label}</span>
            <span className="text-[11px] text-slate-500 tabular-nums">{plans.length}</span>
          </div>
          {plans.length > 0 ? (
            <span className="text-[11px] font-semibold tabular-nums text-slate-700">
              {formatMoney(total, currency)}
            </span>
          ) : null}
        </div>
        <div className="mt-0.5 text-[10px] text-slate-500">{state.sortHint}</div>
      </div>

      <div className="flex-1 px-2 py-2 space-y-2 overflow-y-auto min-h-[120px]">
        {plans.length === 0 ? (
          <div className="text-[11px] text-slate-400 italic px-2 py-4 text-center">
            No plans
          </div>
        ) : (
          plans.map((p) => <TxPlanCard key={p.id} plan={p} currency={currency} onOpen={onOpen} />)
        )}
      </div>
    </div>
  );
}
